const TRACK_ID_PATTERN = /^[a-z0-9][a-z0-9'.-]{0,179}$/;
const DIRECT_ENDPOINTS = Object.freeze({
  "vonthekeyz-site": "https://us-east1-vonthekeyz-site.cloudfunctions.net/apiV2/catalog-preview",
  "vonthekeyz-staging": "https://us-east1-vonthekeyz-staging.cloudfunctions.net/apiV2/catalog-preview",
});

export function publicCatalogPreviewUrl(trackId, projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID) {
  const id = String(trackId || "").normalize("NFKC").trim();
  const endpoint = DIRECT_ENDPOINTS[String(projectId || "").trim()];
  if (!endpoint || !TRACK_ID_PATTERN.test(id) || id.includes("..") || /%[0-9a-f]{2}/i.test(id)) return "";
  return `${endpoint}?trackId=${encodeURIComponent(id)}`;
}

export function withPublicCatalogPreview(track = {}) {
  const audioURL = publicCatalogPreviewUrl(track.id || track.trackId);
  return audioURL ? {...track, audioURL} : {...track, audioURL: ""};
}

export {DIRECT_ENDPOINTS, TRACK_ID_PATTERN};
